

import monthlypayroll from './monthlypayroll/index.js'
import utilities from './utilities/index.js'
import reports from './reports/index.js'
import employees from './employees/employees.js'
import incometax from './incometax/incometax.js'
import stdReports from './stdReports/stdReports.js'
import newReports from './newReports/newReports.js'
export default {
namespaced: true,
modules: {
 monthlypayroll: monthlypayroll,
 reports:reports,
  utilities: utilities,
  employees:employees,
  incometax:incometax,
  stdReports: stdReports,
  newReports: newReports,
 }
}